import * as cssVariable from 'cssVariables';
import { breakpoints, mediaQuery } from 'components/theme/breakpoints';

export default {
  auth: {
    display: 'flex',
    marginLeft: 15,
  },

  profileThumb: {
    display: 'inline-block',
    width: 28,
    height: 28,
    margin: '0 10px',
    backgroundSize: 'cover',
    borderRadius: '50%',
    [mediaQuery.maxWidth(breakpoints.md)]: {
      margin: 0,
    },
  },

  authButton: {
    textTransform: 'capitalize',
    marginRight: 15,
  },

  dropBtn: {
    height: 30,
    background: cssVariable.white,
    border: 0,
    color: '#0091FF',
    fontWeight: 'bold',
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  chevron: {
    transform: 'rotate(90deg)',
    color: cssVariable.blue500,
    width: '2.4em',
    height: '2.4em',
    position: 'relative',
    left: -5,
  },

  turnChevron: {
    transform: 'rotate(270deg)',
  },

  dropdownHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 150,
    height: '100%',
  },

  dropdownHeaderOpen: {
    borderBottom: '0.3px solid rgba(0,0,0,0.1)',
    boxShadow: '2px 8px 17px 0 rgba(116,116,116,0.5)',
    borderRadius: [3, 3, 0, 0],
  },

  dropdown: {
    cursor: 'pointer',
    height: 70,
  },

  dropdownContent: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    background: cssVariable.white,
    width: 150,
    color: cssVariable.grey500,
    borderRadius: [0, 0, 3, 3],
    boxShadow: '2px 8px 17px 0 rgba(116,116,116,0.5)',
    clipPath: 'inset(0px -20px -20px -20px)',
  },

  dropdownContentHide: {
    display: 'none',
  },

  links: {
    textDecoration: 'none',
    fontWeight: 'bold',
    color: cssVariable.grey500,
    '&:hover': {
      color: cssVariable.blue500,
    },
    lineHeight: 2.5,
  },

  favouriteIcon: {
    width: 18.5,
    height: 17,
    margin: 7,
  },

  dropdownIcons: {
    margin: 4,
  },
  dropdownItem: {
    display: 'flex',
    alignItems: 'center',
    '&:hover, &:hover a': {
      color: cssVariable.blue500,
    },
    padding: 3,
  },

  profileIcon: {
    marginLeft: 5,
  },

  dropdownButtons: {
    background: cssVariable.white,
    border: 0,
    fontWeight: 'bold',
    padding: 0,
  },
};
